import React from 'react';
import PropTypes from 'prop-types';
import WmsMobileLayout from "../wmsMobileLayout";
import PageTitle from "../../../components/WMS/Mobile/PageTitle";
import {FormattedMessage} from "react-intl";
import TrolleyAndStationList from "./components/TrolleyAndStationList";

function TriShipping() {
    return (
        <WmsMobileLayout>
            <WmsMobileLayout.LeftHeader></WmsMobileLayout.LeftHeader>
            <WmsMobileLayout.RightHeader></WmsMobileLayout.RightHeader>

            <WmsMobileLayout.Content>
                <PageTitle title={<FormattedMessage id={"wms.triShipping.pageTitle"}/>} subtitle={<FormattedMessage id={"wms.triShipping.pageSubtitle"}/>}/>
                <TrolleyAndStationList/>
            </WmsMobileLayout.Content>


        </WmsMobileLayout>
    );
}

export default TriShipping;